import { Box } from "@mantine/core";

export const BaseBox = Box;